import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Form, Input, Radio, Row } from 'antd'

const types = {
  contactEmail: 'email',
  contactPhone: 'any',
}

const B2becContactVia = () => {
  const [typeContact, setTypeContact] = useState('contactEmail')
  const { t } = useTranslation()

  return (
    <Form.Item
      noStyle
      label={t(`enquiryModal.form.contactType.${typeContact}`)}
      name={typeContact}
      rules={[
        { required: true },
        {
          type: types[typeContact],
        },
      ]}
    >
      <Row align="middle">
        <Col span={12}>
          <Radio.Group
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }}
            value={typeContact}
            onChange={(e) => setTypeContact(e.target.value)}
          >
            <Radio value="contactEmail">
              {t('enquiryModal.form.contactType.contactEmail')}
            </Radio>
            <Radio value="contactPhone">
              {t('enquiryModal.form.contactType.contactPhone')}
            </Radio>
          </Radio.Group>
        </Col>
        <Col span={12}>
          <Input />
        </Col>
      </Row>
    </Form.Item>
  )
}

export default B2becContactVia
